import store from '../store'
import {
    wtMerchants,
    wtNewPromoForm,
    wtNetworkLimits,
    dictProducts,
    dictProductsPagination,
    processedSubs
} from './wtData'
import { createWt, addSteps } from './wt'

let saveAddNewPromo = {}
let saveMerchants = {}
let saveSteps = {}

async function getInitialSteps() {
    const initState = await store.$storage.getItem('initialState')
    return initState.addNewPromo.steps
}
async function getStorageSteps() {
    const addNewPromoSteps = await store.$storage.getItem('addNewPromoSteps')
    return addNewPromoSteps
}

export const tour = createWt()

const steps = [
    {
        id: 1,
        title: 'Informacje o promocji własnej',
        text:
            'W formularzu uzupełnij najważniejsze informacje o zakładanej przez Ciebie promocji, tj: nazwa promocji, czas trwania oraz typ promocji. Jeśli promocja jest przeznaczona dla użytkowników aplikacji Moje Sklepy, wybierz opcję „Tylko z aplikacją” . Pamiętaj, że nazwa promocji wyświetli się Twoim klientom w aplikacji!',
        attachTo: {
            element: '.--step-0',
            on: 'auto'
        }
    },
    {
        id: 2,
        title: 'Typy promocji',
        text: `
        <h5>Dostępne są trzy typy promocji:</h5>
        <ul>
            <li>Okresowa Obniżka – standardowa obniżka ceny w czasie trwania promocji dla produktów z kodem kreskowym sprzedawanych w jednostkach sztukowych. Np. mleko w cenie 3 zł zamiast 4 zł (cena regularna bez promocji).</li>
            <li>Promo Mix – promocja na zestaw produktów, np. kup 2 piwa w cenie 3 zł / szt.</li>
            <li>Wagowa Okresowa Obniżka – standardowa obniżka ceny w czasie trwania promocji dla produktów bez kodu kreskowego sprzedawanych w jednostkach wagowych i sztukowych. Np. banany w cenie 5 zł/kg zamiast 7 zł (cena regularna bez promocji).</li>
        </ul>
        `,
        attachTo: {
            element: '[data-walk="wtnp-1-2"]',
            on: 'auto'
        }
    },
    {
        id: 3,
        title: 'Sklepy z promocją własną',
        text:
            'Po uzupełnieniu niezbędnych pól, pojawi Ci się komunikat, w ilu sklepach możesz uruchomić daną promocję w wybranym przedziale czasowym.',
        attachTo: {
            element: '.o-addPromo__footer',
            on: 'auto'
        }
    },
    {
        id: 4,
        title: 'Usuwanie informacji',
        text:
            'Możesz usunąć wszystkie wprowadzone dane poprzez kliknięcie w przycisk „Wyczyść formularz”.',
        attachTo: {
            element: '.o-addPromo__clearFormBtn',
            on: 'auto'
        }
    },
    {
        id: 5,
        title: 'Przejście do kolejnego kroku',
        text: 'Kliknij „Dalej” i przejdź do formularza Wyboru Sklepów.',
        attachTo: {
            element: '.o-addPromo__btn--next',
            on: 'auto'
        },
        actionNext: () => {
            const button = document.querySelector('.o-addPromo__btn--next')
            button.click()
        }
    },
    {
        id: 6,
        title: 'Wybór sklepów',
        text:
            'Z listy sklepów wybierz te, w których zostanie aktywowana Twoja promocja. Przy każdym sklepie po prawej stronie masz podaną liczbę założonych w nim promocji własnych oraz ich limit w danej placówce w wybranym przez Ciebie przedziale czasowym.',
        attachTo: {
            element: '.card',
            on: 'auto'
        },
        actionPrev: () => {
            const button = document.querySelector('.o-addPromo__btn--prev')
            button.click()
        },
        actionNext: () => {
            store.dispatch('setNetworkLimits', wtNetworkLimits)
        }
    },
    {
        title: 'Wybór sklepów',
        text:
            'Jeśli wykorzystałeś limit, a wciąż chcesz założyć promocję, możesz dezaktywować wcześniej uruchomioną promocję własną.',
        attachTo: {
            element: '.t-shops-row__limits',
            on: 'auto'
        },
        actionNext: () => {
            store.dispatch('setNetworkLimits', wtNetworkLimits)
        }
    },
    {
        id: 7,
        title: 'Przejście do kolejnego kroku',
        text:
            'Po wyborze sklepów kliknij „Dalej” i przejdź do formularza Wyboru Produktów.',
        attachTo: {
            element: '.o-addPromo__btn--next',
            on: 'auto'
        },
        actionNext: () => {
            const button = document.querySelector('.o-addPromo__btn--next')
            button.click()
        }
    },
    {
        id: 8,
        title: 'Dodawanie produktów do promocji',
        text:
            'Aby dodać produkt do promocji, kliknij w „Dodaj produkt”. Do promocji własnej możesz załadować maksymalnie 100 produktów.',
        attachTo: {
            element: '.--step-2 main',
            on: 'auto'
        },
        actionPrev: () => {
            const button = document.querySelector('.o-addPromo__btn--prev')
            button.click()
        },
        actionNext: () => {
            store.dispatch('setDictProducts', dictProducts)
            store.dispatch('setDictProductsPagination', dictProductsPagination)
            const button = document.querySelector(
                '.o-tableAddPromoProducts__addProductBtn'
            )
            button.click()
            setTimeout(() => {
                const modal = document.querySelector('.m-selectionProducts')
                const input = modal.querySelector('.form-control')
                input.value = 'Ziemniak'
            }, 0)
        }
    },
    {
        id: 9,
        title: 'Wyszukiwarka produktów',
        text: 'Produkty możesz wyszukiwać po nazwie lub numerze EAN.',
        attachTo: {
            element: '.m-selectionProducts',
            on: 'auto'
        },
        actionPrev: () => {
            store.dispatch('toggleModal', false)
        },
        actionNext: () => {
            const button = document.querySelector(
                '.o-tableAddPromoProducts__addProductBtn'
            )
            button.click()
        }
    },
    {
        id: 10,
        title: 'Wybór produktu',
        text:
            'Aby wybrać interesujący Cię produkt, kliknij w przycisk „Wybierz” po prawej stronie. <div class="flex-grow-1 text-sm a-infoBar a-infoBar--warning mt-3"><h6 class="mb-0">UWAGA!</h6>Jeśli dany produkt znajduje się już w promocji organizatora sieci w tym samym czasie co Twoja promocja własna, produkt zostanie objęty promocją organizatora sieci.</div>',
        attachTo: {
            element: '.c-tr .btn',
            on: 'auto'
        },
        actionNext: async () => {
            const buttons = document.querySelectorAll('.c-tr .btn')
            buttons[0].click()
            buttons[2].click()
            const products = await store.getters.getNewPromoForm.step3.products
            wtNewPromoForm.step3.products = products
        }
    },
    {
        id: 11,
        title: 'Zapis wyborów',
        text: 'Po wyborze wszystkich produktów, kliknij "Zapisz"',
        attachTo: {
            element: '.modal-footer .btn',
            on: 'auto'
        },
        actionPrev: () => {
            wtNewPromoForm.step3.products.value = []
        },
        actionNext: () => {
            const inputs = document.querySelectorAll(
                '.o-tableAddPromoProducts__productPrice .form-control'
            )
            inputs[0].value = '6.00'
            wtNewPromoForm.step3.products.value[0].merchant_prices[0].promo_price =
                '6.00'
            inputs[1].value = '9.00'
            wtNewPromoForm.step3.products.value[1].merchant_prices[0].promo_price =
                '9.00'
            store.dispatch('setAddNewPromoForm', wtNewPromoForm)
            const button = document.querySelector('.modal-footer .btn')
            button.click()
        }
    },
    {
        id: 12,
        title: 'Cena promocyjna produktów',
        text: 'Dla każdego z wybranych produktów ustal cenę promocyjną.',
        attachTo: {
            element: '.o-addPromo main',
            on: 'auto'
        },
        actionPrev: () => {
            const inputs = document.querySelectorAll(
                '.o-tableAddPromoProducts__productPrice .form-control'
            )
            inputs[0].value = '0.00'
            wtNewPromoForm.step3.products.value[0].merchant_prices[0].promo_price =
                '0.00'
            inputs[1].value = '0.00'
            wtNewPromoForm.step3.products.value[1].merchant_prices[0].promo_price =
                '0.00'
            store.dispatch('setAddNewPromoForm', wtNewPromoForm)

            store.dispatch('setDictProducts', dictProducts)
            store.dispatch('setDictProductsPagination', dictProductsPagination)
            const button = document.querySelector(
                '.o-tableAddPromoProducts__addProductBtn'
            )
            button.click()
        },
        actionNext: () => {
            const inputs = document.querySelectorAll(
                '.o-tableAddPromoProducts__productImg .custom-control-input'
            )
            inputs[0].click()
        }
    },
    {
        id: 13,
        title: 'Zdjęcie produktu przy promocji',
        text:
            'Zaznacz checkbox „Zdjęcie w aplikacji” przy produkcie, którego zdjęcie ma się pojawić jako główne przy założonym module promocyjnym. <div class="flex-grow-1 text-sm a-infoBar a-infoBar--warning mt-3"><h6 class="mb-0">UWAGA!</h6> <strong>Jeśli należysz do aplikacji Moje Sklepy</strong>, wybrane zdjęcie będzie zdjęciem głównym w pojedynczym module w sekcji „Tylko w Twoim sklepie” w aplikacji. Dlatego zalecamy, aby promocja własna składała się z produktów homogenicznych (np. butelka piwa 400 ml w różnych wariantach smakowych). Jeśli chcesz uwzględnić produkt z innej kategorii, załóż kolejną promocję własną.</div>',
        attachTo: {
            element:
                '.o-tableAddPromoProducts__productImg .custom-control-input',
            on: 'auto'
        },
        actionPrev: () => {
            const inputs = document.querySelectorAll(
                '.o-tableAddPromoProducts__productImg .custom-control-input'
            )
            inputs[0].click()
        }
    },
    {
        id: 14,
        title: 'Usuwanie produktów z listy',
        text:
            'Jeśli chcesz usunąć z listy pojedynczy produkt, kliknij w ikonę śmietnika po prawej stronie. Możesz też usunąć wszystkie produkty z listy, klikając w przycisk „Usuń wszystkie produkty”',
        attachTo: {
            element: '.o-tableAddPromoProducts__productDel .btn',
            on: 'auto'
        },
        actionNext: () => {
            const inputs = document.querySelectorAll(
                '.o-tableAddPromoProducts__localCode .form-control'
            )
            inputs[0].classList.add('has-content')
            inputs[0].value = '123456'
            wtNewPromoForm.step3.products.value[0].merchant_prices[0].alternative_ean =
                '123456'
            inputs[1].value = '456789'
            inputs[1].classList.add('has-content')
            wtNewPromoForm.step3.products.value[1].merchant_prices[0].alternative_ean =
                '456789'
            store.dispatch('setAddNewPromoForm', wtNewPromoForm)
        }
    },
    {
        id: 15,
        title: 'Uzupełnianie kodu lokalnego',
        text:
            'Do każdej promocji z produktami zmiennowagowymi i niektórymi produktami sztukowymi (np. sałata) należy uzupełnić pole z kodem lokalnym, aby prawidłowo obsłużyć i rozliczyć promocję.',
        attachTo: {
            element: '.o-tableAddPromoProducts__localCode',
            on: 'auto'
        },
        actionPrev: () => {
            const inputs = document.querySelectorAll(
                '.o-tableAddPromoProducts__localCode .form-control'
            )
            inputs[0].value = ''
            inputs[0].classList.remove('has-content')
            wtNewPromoForm.step3.products.value[0].merchant_prices[0].alternative_ean =
                ''
            inputs[1].value = ''
            inputs[1].classList.remove('has-content')
            wtNewPromoForm.step3.products.value[1].merchant_prices[0].alternative_ean =
                ''
            store.dispatch('setAddNewPromoForm', wtNewPromoForm)
        }
    },
    {
        id: 16,
        title: 'Przejście do kolejnego kroku',
        text:
            'Po wyborze produktów i ustaleniu cen, kliknij „Dalej”, aby przejść do podsumowania.',
        attachTo: {
            element: '.o-addPromo__btn--next',
            on: 'auto'
        },
        actionNext: () => {
            const button = document.querySelector('.o-addPromo__btn--next')
            button.click()
        }
    },
    {
        id: 17,
        title: 'Podsumowanie promocji',
        text:
            'Zapoznaj się z podsumowaniem promocji. Jeśli wszystkie ustalenia zgadzają się, kliknij w „Utwórz i aktywuj w sklepie”.',
        attachTo: {
            element: '.--step-3 main',
            on: 'auto'
        },
        actionPrev: () => {
            const button = document.querySelector('.o-addPromo__btn--prev')
            button.click()
        }
    },
    {
        id: 18,
        title: 'Powrót do wcześniejszych kroków w formularzu',
        text:
            'Jeśli chcesz wrócić do wcześniejszych etapów kreatora promocji, możesz to zrobić, klikając w interesujący Cię etap na górnej osi. <strong>Zawsze możesz również użyć klawisza wstecz w lewym dolnym rogu każdego ekranu.</strong>',
        attachTo: {
            element: (() => {
                let element
                if (window.innerWidth < 992) {
                    element = '.m-stepProgressBar__mobile'
                } else {
                    element = '.m-stepProgressBar__desktop'
                }
                return element
            })(),
            on: 'auto'
        },
        actionNext: () => {
            const button = document.querySelector('.o-addPromo__btn--next')
            store.dispatch('setProcessedSubscriptions', processedSubs)
            button.click()
        }
    },
    {
        id: 19,
        title: 'Generowanie cenówek',
        text:
            'Po aktywacji promocji możesz w łatwy sposób wygenerować cenówki. Pamiętaj, aby komunikować swoje oferty promocyjne w sklepie!',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        },
        actionPrev: () => {
            store.dispatch('toggleModal', false)
        }
    },
    {
        id: 20,
        title: 'Szczegóły promocji',
        text:
            'Możesz podejrzeć szczegóły założonej promocji, klikając w „Przejdź do szczegółów promocji” lub założyć kolejną, klikając w „Załóż kolejną promocję”.',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        }
    }
]

addSteps(tour, steps)

tour.on('start', async function(arg) {
    if (wtNewPromoForm.step3.main_image_dict_product_id.value) {
        wtNewPromoForm.step3.main_image_dict_product_id.value = null
    }

    const firstStep = document.querySelector('.m-stepProgressBar__step')
    firstStep.click()
    document.body.classList.add('walkthrough')
    document.getElementsByTagName('html')[0].style.scrollBehavior = 'auto'
    store.dispatch('setWalkthroughActive', true)

    const wtSteps = await getInitialSteps()
    saveSteps = await getStorageSteps()
    saveAddNewPromo = store.getters.getNewPromoForm
    saveMerchants = store.getters.getAvailableMerchants

    store.dispatch('setAddNewPromoForm', wtNewPromoForm)
    store.dispatch('setMerchants', wtMerchants)
    store.dispatch('setNetworkLimits', wtNetworkLimits)
    store.dispatch('setAddNewPromoSteps', wtSteps)
})

tour.on('show', function() {
    document.body.classList.add('walkthrough')
    store.dispatch('setWalkthroughActive', true)
})

const cancelEvents = ['close', 'cancel', 'complete']
cancelEvents.forEach(event => {
    return tour.on(event, () => {
        wtNewPromoForm.step3.products.value = []
        document.body.classList.remove('walkthrough')
        document.getElementsByTagName('html')[0].style.scrollBehavior = 'smooth'
        store.dispatch('setWalkthroughActive', false)
        window.scrollTo(0, 0)

        store.dispatch('setAddNewPromoForm', saveAddNewPromo)
        store.dispatch('setMerchants', saveMerchants)
        store.dispatch('setAddNewPromoSteps', saveSteps)
        store.dispatch('resetProcessedSubscriptions')
        store.dispatch('toggleModal', false)

        setTimeout(() => {
            const stepIdx = store.getters.getActiveStepIdx
            const steps = document.querySelectorAll('.m-stepProgressBar__step')
            steps[stepIdx].click()
        }, 0)
    })
})
